import consumer from "./consumer"

consumer.subscriptions.create("ChatChannel", {
  connected() {
    // Called when the subscription is ready for use on the server
  },

  disconnected() {
    // Called when the subscription has been terminated by the server
  },

  received(data) {
    if (data.action == 'send_message') {
      var message = {
        created_at: data.created_at,
        content: data.content,
        avatar: data.user_from.avatar,
        name: data.user_from.display_name
      };

      if (data.user_type == 'to') {
        var $chatElement = $(`.chat-messages-${data.user_from.slug} .chat-messages`);
        var $chatPopupElement = $(`#chat_popup_${data.user_from.slug}`);

        message['type'] = 'in';

        if ($chatElement.is(':visible')) {
          message['element'] = $chatElement;

          window.addMessage(message);
        }

        if (!$chatPopupElement.length) {
          window.openChatPopup(data.user_from.slug, data.user_from.display_name, $chatElement.is(':visible'));
        } else {
          message['element'] = $chatPopupElement.find('.chat-list');

          window.addMessage(message);

          if (!$chatElement.is(':visible')) {
            $chatPopupElement.removeClass('d-none');
          }
        }

        playAudio('#audio-notification');
      }

      if (data.user_type == 'from') {
        var $chatElement = $(`.chat-messages-${data.user_to.slug} .chat-messages`);
        var $chatPopupElement = $(`#chat_popup_${data.user_to.slug}`);

        message['type'] = 'out';

        if ($chatElement.is(':visible')) {
          message['element'] = $chatElement;

          window.addMessage(message);
        }

        if (!$chatPopupElement.length) {
          window.openChatPopup(data.user_to.slug, data.user_to.display_name, data.user_from.hide_popup);
        } else {
          message['element'] = $chatPopupElement.find('.chat-list');

          window.addMessage(message);

          if (!$chatElement.is(':visible')) {
            $chatPopupElement.removeClass('d-none');
          }
        }

        playAudio('#audio-notification');
      }
    }
  }
});
